import React, { useState } from 'react';
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import 'react-html5-camera-photo/build/css/index.css';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import arrow1 from "../../../assets/Icons/yellow-left-top.png"
import arrow2 from "../../../assets/Icons/yellow-right-top.png"
import arrow3 from "../../../assets/Icons/yellow-feft-bottom.png"
import arrow4 from "../../../assets/Icons/yellow-right-bottom.png"
import oval from "../../../assets/claraViewMedia/Ellipse 7740.png"
import { GetMobileOperatingSystem } from '../../../Utils/getOS';
import Preview from './preview';
import { GetBrowserDetails } from '../../../Utils/deviceDetails';
import PermissionPopup from './cameraPermissionPopup';
import FrontCameraError from './frontCameraError';
import { getLocalStorageJSON } from '../../../Utils/safeLocalStorage';
import { logEvent } from '../../../Utils/logEvent';
import "./index.css"

const Capture = ({ setDemo }) => {
    const navigate = useNavigate();
    const app = localStorage.getItem("company")
    const uid = getLocalStorageJSON("usertpi").usertpi
    const [capturedImage, setCapturedImage] = useState()
    const [flashLight, setFlashLight] = useState(false)
    const [mediaStream, setStream] = useState(null)
    const [errorType, setErrorType] = useState({ isError: false, type: "ios" })
    const OS = GetMobileOperatingSystem()   // operating system
    const [camera, setCamera] = useState(true)
    const [facialMode, setFacialMode] = useState(FACING_MODES.USER)
    const [frontCameraError, setFrontCameraError] = useState(false)

    useEffect(() => {
        const isScanComplete = localStorage.getItem("isScanCompleted")
        if (!app || !uid || isScanComplete) {
            const client = app?.split("-")[1];
            // navigate(`/${client}`);
        }
    }, []);


    const handleTakePhoto = (dataUri) => {
        setCapturedImage(dataUri)
        logEvent({ app, uid, event: "clicked take photo, previewing" })
        setTimeout(() => {
            setCamera(false)
        }, 400)
    }

    const cameraStarted = (stream) => {
        setStream(stream)
        // handleCameraType()

        handleFrontCamera()
        setErrorType({ isError: false, type: "ios" })
    }

    const handleFrontCamera = () => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');

                const frontCamera = videoDevices.find(device => device.getCapabilities().facingMode?.includes("user"));
                if (frontCamera) {
                    setFacialMode(frontCamera.deviceId); // Set the deviceId directly
                } else {
                    setFacialMode(FACING_MODES.ENVIRONMENT); // Fallback to rear camera
                    setFrontCameraError(true)
                }
            })
            .catch(err => {
                logEvent({ app, uid, event: "Error enumerating devices", error: err });
                setFacialMode(FACING_MODES.ENVIRONMENT);
                setFrontCameraError(true);
            });
    }

    const checkError = () => {
        const browser = GetBrowserDetails();

        if (browser.name === "Mobile Chrome") {
            navigator.permissions.query({ name: 'camera' }).then((res) => {
                if (res.state === "denied") {
                    if (OS === 'iOS') {
                        setErrorType({ isError: true, type: "ios" })
                    } else {
                        setErrorType({ isError: true, type: "android" })
                    }
                }
            }).catch((error) => {
                setErrorType({ isError: true, type: "ios" })
            })

        } else {
            setErrorType({ isError: true, type: "ios" })
        }

    }

    const onClose = () => {
        setCapturedImage(null)
        setCamera(true)
    }

    const handleRetake = () => {
        logEvent({ app, uid, event: "re-taking the capture" })
        setCapturedImage(null)
        setCamera(true)
    }



    const OvuleShape = () => {
        return (
            <div className="ovule-container h-full w-full flex flex-col justify-center items-center font-novatica">
                {/* bg-[#808483] */}
                <div className="relative w-full h-full flex flex-col justify-evenly items-center">
                    {/* Face Outline - using viewport units for responsive sizing */}
                    <div className=" inset-0 bg-transparent flex justify-center items-center ">
                        <img src={oval} className="w-auto max-h-[60vh] max-w-[90%] object-contain" alt="oval shape" />
                    </div>
                    <div className="flex flex-col justify-center items-center">


                        <p className="mb-4 border-2 border-white text-base text-center text-[#FFFFFF] w-3/4 font-regular rounded-lg px-4 py-1 md:text-2xl md:w-96 sm600:text-base sm600:w-full">
                            Tap anywhere to capture
                        </p>


                        <p className=" mb-16 border-2 border-white text-base text-center text-[#FFFFFF] w-3/4 font-regular rounded-lg px-4 py-5 bg-[rgba(111,111,110,0.42)] md:text-2xl md:w-96 sm600:text-2xl sm600:w-full">
                            Center your head within the outline, smile, and tap to start your preview
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    const TopLayer = () => {
        return (
            <div className=' top-0 left-0 bg-slate-600 text-white w-full  z-50'>
                {/* Back Button Top Left */}
                <div className='absolute top-0 left-0 h-13 p-4'>
                    <button type='button' onClick={() => { window.history.back() }}>
                        <img src={arrow1} alt="back" className="w-8 h-8" />
                    </button>
                </div>

                {/* Back Button Top Right */}
                <div className='absolute top-0 right-0 h-13 p-4'>
                    <button type='button' onClick={() => { window.history.back() }}>
                        <img src={arrow2} alt="back" className="w-8 h-8" />
                    </button>
                </div>

                {/* Back Button Bottom Left */}
                <div className='absolute bottom-0 left-0 p-4'>
                    <button type='button' onClick={() => { window.history.back() }}>
                        <img src={arrow3} alt="back" className="w-8 h-8" />
                    </button>
                </div>

                {/* Back Button Bottom Right */}
                <div className='absolute bottom-0 right-0  p-4'>
                    <button type='button' onClick={() => { window.history.back() }}>
                        <img src={arrow4} alt="back" className="w-8 h-8 " />
                    </button>
                </div>
            </div>


        )
    }
    return (
        <div className='h-full'>

            {
                camera ? <> <Camera
                    onTakePhoto={(dataUri) => { handleTakePhoto(dataUri); }}
                    idealFacingMode={facialMode} // Set back camera preference
                    isFullscreen={false}
                    isMaxResolution={true}
                    imageType={IMAGE_TYPES.JPG}
                    imageCompression={0.9}
                    sizeFactor={1}
                    videoConstraints={{
                        facingMode: { exact: "user" }, // Force front camera
                        width: { ideal: window.innerWidth },
                        height: { ideal: window.innerHeight },
                        aspectRatio: { ideal: window.innerWidth / window.innerHeight }
                    }}
                    isImageMirror={facialMode !== FACING_MODES.ENVIRONMENT}
                    onCameraStart={cameraStarted}
                    onCameraError={checkError}
                    className="WebCam"
                />
                    <TopLayer />
                    <OvuleShape />
                    {errorType.isError && <PermissionPopup info={errorType} setErrorType={setErrorType} />}
                    {!errorType.isError && frontCameraError && <FrontCameraError back={setFrontCameraError} />}


                </> : <Preview image={capturedImage} setCamera={handleRetake} onClose={onClose} setDemo={() => { window.history.back() }} />
            }
        </div>
    );
};

export default Capture;